import { ReactElement } from 'react';

import { isStringBase64 } from '@cashier/cashier-common';
import { InputTypes } from '@cashier/cashier-model';

import styles from './styles.module.scss';

interface QrCodeProperties {
  value: string;
  type: 'square' | 'rectangle';
}

export const QrCode = ({ value, type }: QrCodeProperties): ReactElement => {
  const imageSource = isStringBase64(value)
    ? `data:image/png;base64,${value}`
    : value;

  return (
    <div className={styles.wrapper}>
      <img
        src={imageSource}
        alt={InputTypes.QrCode}
        className={styles[type]}
        data-test="qrCode"
      />
    </div>
  );
};
